<i class="fas fa-comment-alt"></i>
<span>{{count}}</span>